import { CloudinaryAsset, CloudinaryProductAsset } from 'shared/types/content';

export const getMediaId = (asset: CloudinaryAsset | CloudinaryProductAsset) => {
  const version = asset.version;
  const publicId = 'publicId' in asset ? asset.publicId : asset.public_id;

  return `v${version}/${publicId}`;
};
